import React from "react";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";

export default function PortalLanguageSwitch() {
  const [, i18n] = useTranslation("common");
  const current = (i18n.language || "sk").startsWith("en") ? "en" : "sk";

  const setLang = (ln) => {
    i18n.changeLanguage(ln);
    try {
      Cookies.set("ln", ln);
      localStorage.setItem("ln", ln);
    } catch (e) {}
  };

  const btn = (ln, label) => (
    <button
      type="button"
      onClick={() => setLang(ln)}
      aria-pressed={current === ln}
      style={{
        padding: "4px 8px",
        borderRadius: 4,
        border: "1px solid #d9d9d9",
        background: current === ln ? "#ee2723" : "#fff",
        color: current === ln ? "#fff" : "#111",
        cursor: "pointer",
      }}
    >
      {label}
    </button>
  );

  return (
    <div style={{ display: "inline-flex", gap: 8, alignItems: "center" }}>
      {btn("sk", "SK")}
      {btn("en", "EN")}
    </div>
  );
}
